var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#F5F7FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "black",
    strokeOpacity: 0.1002
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.166 37.3332V13.3332C11.166 12.5998 11.4271 11.9721 11.9493 11.4498C12.4716 10.9276 13.0993 10.6665 13.8327 10.6665H35.166C35.8994 10.6665 36.5271 10.9276 37.0494 11.4498C37.5716 11.9721 37.8327 12.5998 37.8327 13.3332V21.3332H35.166V13.3332H13.8327V30.8332L15.366 29.3332H28.4993V31.9998H16.4993L11.166 37.3332ZM33.8327 38.6665V31.9998H31.166V23.9998H37.8327L35.566 29.3332H38.4993L33.8327 38.6665Z",
    fill: "#5F6368",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChips);
export default __webpack_public_path__ + "static/media/Chips.02044ef5d817865fb33ad825b03a218a.svg";
export { ForwardRef as ReactComponent };